/**
 * Design tokens — single source of truth for theme color values.
 * Legacy palette keys (Tertiary, Grey, etc.) remain on palette for existing components.
 */
export const colors = {
  primary: {
    // main: '#3F7DBC',#0E4979
    main: '#0E4979',
    dark: '#3375BB',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#50AD20',
    light: '#DBEFCD',
    dark: '#47A663',
    navy:"#001F3F",
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#E84C3D',
    light: '#F94F59',
    dark: '#D52020',
  },
  text: {
    primary: '#1F3048',
    secondary: '#8A8C8F',
    third:"#044477",
    tertiary: '#93B0C8',
    disabled: '#CACACA',
    gray: "#707070",
    disabled2: "#A0A0A0",
    header: "#798391"
  },
  background: {
    default: '#F0F7FD',
    paper: '#FFFFFF',
    elevated: '#ECF3F9',
    subtle: '#F1F5F9',
    settings: '#F6FBFF',
    infoPanel: '#EAF4FF66',
    iconBox: '#E6EDF5',
    successBadge: '#DCEFD2',
    cardBg: "#fafafa",
    cardDivBg:"#F3F3F3",
  },
  border: {
    default: '#E0E0E0',
    light: '#CFCFCF',
    divider: '#DBE5EE',
    card: "#00000026",
    cardDiv:"#D9D9D9",
    mild:"#00000033",
    grey:"#cccccc"
  },
  /** Navigation active state colors */
  nav: {
    activeBackground: '#EDF7E6',
    activeBorder: '#50AD20',
    labelColor: '#8F97A4',
    activeColor: "#7AC159",
  },
  /** @deprecated Use palette keys via color prop — kept for backward compatibility */
  legacy: {
    Tertiary: '#93B0C8',
    Errors: '#E84C3D',
    Bg_color: '#F0F7FD',
    Title_Text_color: '#CACACA',
    White_color: '#FFFFFF',
    Heading_color: '#1F3048',
    Grey: '#8A8C8F',
  },
  status: {
    danger: '#e53e3e',
  },
  neutral: {
    outlinedText2: '#111111',
    outlinedText: '#0D0C2C',
    sliderRail: '#E0E0E0',
    shimmerLight: '#f5f5f5',
    subText: "#00000099",
    info100: "#2685CA",
    success100: "#3F845F",
    orange100: "#FA8E16"
  },
 success: {
    main: '#008000',
  },
  error: {
    main: '#FF0000',
    secondary: "#E25C5C"
  },
};

export const lightColors  = {
  primary: {
    // main: '#3F7DBC',#0E4979
    main: '#0E4979',
    dark: '#3375BB',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#50AD20',
    light: '#DBEFCD',
    dark: '#47A663',
    navy:"#001F3F",
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#E84C3D',
    light: '#F94F59',
    dark: '#D52020',
  },
  text: {
    primary: '#1F3048',
    secondary: '#8A8C8F',
    third:"#044477",
    tertiary: '#93B0C8',
    disabled: '#CACACA',
    gray: "#707070",
    disabled2: "#A0A0A0",
    header: "#798391"
  },
  background: {
    default: '#F0F7FD',
    paper: '#FFFFFF',
    elevated: '#ECF3F9',
    subtle: '#F1F5F9',
    settings: '#F6FBFF',
    infoPanel: '#EAF4FF66',
    iconBox: '#E6EDF5',
    successBadge: '#DCEFD2',
    cardBg: "#fafafa",
    cardDivBg:"#F3F3F3",
  },
  border: {
    default: '#E0E0E0',
    light: '#CFCFCF',
    divider: '#DBE5EE',
    card: "#00000026",
    cardDiv:"#D9D9D9",
    mild:"#00000033",
    grey:"#cccccc"
  },
  /** Navigation active state colors */
  nav: {
    activeBackground: '#EDF7E6',
    activeBorder: '#50AD20',
    labelColor: '#8F97A4',
    activeColor: "#7AC159",
  },
  /** @deprecated Use palette keys via color prop — kept for backward compatibility */
  legacy: {
    Tertiary: '#93B0C8',
    Errors: '#E84C3D',
    Bg_color: '#F0F7FD',
    Title_Text_color: '#CACACA',
    White_color: '#FFFFFF',
    Heading_color: '#1F3048',
    Grey: '#8A8C8F',
  },
  status: {
    danger: '#e53e3e',
  },
  neutral: {
    outlinedText2: '#111111',
    outlinedText: '#0D0C2C',
    sliderRail: '#E0E0E0',
    shimmerLight: '#f5f5f5',
    subText: "#00000099",
    info100: "#2685CA",
    success100: "#3F845F",
    orange100: "#FA8E16"
  },
 success: {
    main: '#008000',
  },
  error: {
    main: '#FF0000',
    secondary: "#E25C5C"
  },
};

export const darkColors  = {
  primary: {
    // main: '#3F7DBC',#0E4979
    main: '#0E4979',
    dark: '#3375BB',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#50AD20',
    light: '#DBEFCD',
    dark: '#47A663',
    navy:"#001F3F",
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#E84C3D',
    light: '#F94F59',
    dark: '#D52020',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#8A8C8F',
    third:"#044477",
    tertiary: '#93B0C8',
    disabled: '#CACACA',
    gray: "#707070",
    disabled2: "#A0A0A0",
    header: "#798391"
  },
  background: {
    default: '#F0F7FD',
    paper: '#222E37',
    elevated: '#ECF3F9',
    subtle: '#F1F5F9',
    settings: '#F6FBFF',
    infoPanel: '#EAF4FF66',
    iconBox: '#E6EDF5',
    successBadge: '#DCEFD2',
    cardBg: "#171e24",
    cardDivBg:"#F3F3F3",
  },
  border: {
    default: '#E0E0E0',
    light: '#CFCFCF',
    divider: '#DBE5EE',
    card: "#00000026",
    cardDiv:"#D9D9D9",
    mild:"#00000033",
    grey:"#cccccc"
  },
  /** Navigation active state colors */
  nav: {
    activeBackground: '#EDF7E6',
    activeBorder: '#50AD20',
    labelColor: '#8F97A4',
    activeColor: "#7AC159",
  },
  /** @deprecated Use palette keys via color prop — kept for backward compatibility */
  legacy: {
    Tertiary: '#93B0C8',
    Errors: '#E84C3D',
    Bg_color: '#F0F7FD',
    Title_Text_color: '#CACACA',
    White_color: '#FFFFFF',
    Heading_color: '#1F3048',
    Grey: '#8A8C8F',
  },
  status: {
    danger: '#e53e3e',
  },
  neutral: {
    outlinedText2: '#111111',
    outlinedText: '#0D0C2C',
    sliderRail: '#E0E0E0',
    shimmerLight: '#f5f5f5',
    subText: "#00000099",
    info100: "#2685CA",
    success100: "#3F845F",
    orange100: "#FA8E16"
  },
 success: {
    main: '#008000',
  },
  error: {
    main: '#FF0000',
    secondary: "#E25C5C"
  },
};

export const color = lightColors;

export const shape = {
  borderRadius: 8,
};

export const layout = {
  pageMaxWidth: 1580,
  cardRadius: 18,
  buttonHeight: 41,
  actionButtonHeight: 42,
};


